<div class="card flex justify-center">
  <p-select [options]="langs()" [(ngModel)]="selectedLang" optionLabel="name" placeholder="" class="w-full md:w-56">
    <ng-template #selectedItem let-selectedOption>
      @if (selectedOption) {
        <div class="flex items-center gap-2 select-preferred-lang">
          <img
            src="images/flags/{{ selectedOption.code | lowercase }}.png"
            [class]="'flag flag-' + (selectedOption.code | lowercase)"
            style="width: 50px" />
        </div>
      }
    </ng-template>
    <ng-template let-lang #item>
      <div class="flex items-center gap-2 d-flex gap-10">
        <img
          src="images/flags/{{ lang.code | lowercase }}.png"
          [class]="'flag flag-' + (lang.code | lowercase)"
          style="width: 20px; border-radius: 50%" />
        <div>{{ lang.code }}</div>
      </div>
    </ng-template>
  </p-select>
</div>
